export default function About() {
	return (
		<>
		<div style={{padding: '16px'}}>
		<h1>Om Billigesexleker.no</h1>
			<article>
				<p>
					Billisexleker.no tilbyr prissammenligning på sexleketøy for forbrukeren.					
					Vårt ønske er å gjøre intim glede tilgjengelig for alle! - Uansett erfaring eller budsjett.
					På billigesexleker.no forstår vi viktigheten av et sunt og tilfredsstillende sexliv. 
					Derfor streber vi etter å tilby et bredt spekter av spennende produkter som kan bidra til å 
					forbedre intimiteten og glede i alle slags forhold. 😏
					Vårt sortiment omfatter alt fra vibrerende leketøy, dildoer, masturbatorer, analleketøy, BDSM-utstyr, 
					undertøy og mye mer fra de største norske annerkjente nettbutikkene som driver med salg av sexleketøy. 
					På denne måten, får du god oversikt over produktene på markedet og kan enkelt finne det som passer deg og din lommebok best! 🎉 
				</p>
				<h2>Kontakt</h2>
				<p>
					Spørsmål, ris eller ros? Send oss gjerne en e-post på <a href="mailto:post@billigesexleker.no" rel="nofollow">post@billigesexleker.no</a>.
				</p>
			</article>
			</div>
		</>
	)
}